import React, { useEffect, useState } from "react"
import { IMG } from "../CONST"
import * as TrinityAPI from "../../../requests/TrinityAPI"
import { IConversationResponse } from "../../../types/messenger/IConversationResponse"
import { Message } from "./Message"
import { ICreateMessageRequest } from "../../../types/messenger/ICreateMessageRequest"
import { CommonFileInput } from "../element/fields/CommonFileInput"
import { IB64File } from "../../../types/IB64File"
import { IMetaItem } from "../../../types/messenger/IMetaItem"

export const Messenger: React.FC<{
  instanceId: string | undefined
  type: string | undefined
  userId: number | undefined
  close: () => void
}> = ({ instanceId, type, userId, close }) => {
  const [page] = useState(0)
  const [conversation, setConversation] = useState<IConversationResponse>()
  const [messageRequest, setMessageRequest] = useState<ICreateMessageRequest>()
  const [fileSend, setFileSend] = useState(false)
  const [altHold, setAltHold] = useState(false)

  useEffect(() => {
    setConversation(undefined)
    fetchMessages()
  }, [instanceId])

  useEffect(() => {
    const intervalId = setInterval(() => {
      fetchMessages()
    }, 3000)

    return () => {
      clearInterval(intervalId)
    }
  }, [instanceId])

  const fetchMessages = () => {
    if (instanceId && type) {
      TrinityAPI.getConversation(type, instanceId, page, response => {
        if (response.status === 200) {
          setConversation(response.data)
        }
      })
    }
  }

  const sendMessage = (request: ICreateMessageRequest) => {
    TrinityAPI.sendMessage(request, response => {
      if (response.status === 200) {
        fetchMessages()
        setMessageRequest({ text: "" })
        setFileSend(false)
      } else {
        setFileSend(false)
      }
    })
  }

  const submit = () => {
    if (messageRequest && messageRequest.text) {
      sendMessage(messageRequest)
    }
  }

  const submitFile = (f: IB64File) => {
    const meta: IMetaItem = {
      fileName: f.name,
      b64: f.b64
    }
    const fileRequest: ICreateMessageRequest = {
      userId: userId,
      type: type,
      instanceId: instanceId,
      metas: new Array(meta)
    }
    setFileSend(true)
    sendMessage(fileRequest)
  }

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.altKey || event.metaKey) {
      setAltHold(true)
    }

    if (event.key === "Enter" && altHold) {
      setMessageRequest({
        ...messageRequest,
        text: messageRequest?.text + "\r\n"
      })
    } else if (event.key === "Enter") {
      submit()
    }
  }

  const handleKeyUp = (event: React.KeyboardEvent) => {
    setAltHold(false)
  }

  if (instanceId && type && userId) {
    return (
      <section className="chat-right-window">
        <div className="container-chat-window">
          <div className="header-chat-window">
            <p className="chat-number-request">
              {type === "REQUEST" ? "Запрос" : type === "ORDER" ? "Ордер" : "Пополнение"} №{instanceId}
            </p>
            <button className="close-chat-window">
              <img src={IMG.close} alt="" className="close-chat-window-img" onClick={close} />
            </button>
          </div>
          <div className="container-chat-message">
            <ul className="chat-window-list">
              {conversation?.messages?.map((m, index) => <Message key={index} message={m} />)}
              {/*<li className="file-my-chat">*/}
              {/*  <p className="username-message-chat">*/}
              {/*    Админ или юзер*/}
              {/*  </p>*/}
              {/*  <img src="layout/assets/svg/file_send.svg" alt=""*/}
              {/*       className="file-send-chat-message"/>*/}
              {/*  1 файл pdf*/}
              {/*  <span className="message-date-time">12.02.2024 12:43</span>*/}
              {/*</li>*/}
              {/*<li className="message-my-chat">*/}
              {/*  <p className="username-message-chat">*/}
              {/*    Админ или юзер*/}
              {/*  </p>*/}
              {/*  Привет! Ну че ты там созрел нет? Сколько можно уже ждать тебя*/}
              {/*  <span className="message-date-time">12.02.2024 12:43</span>*/}
              {/*</li>*/}
              {/*<li className="message-for-me-chat">*/}
              {/*  <p className="username-message-chat">*/}
              {/*    Админ или юзер*/}
              {/*  </p>*/}
              {/*  Привет! Ну че ты там созрел нет? Сколько можно уже ждать тебя*/}
              {/*  <span className="message-date-time">12.02.2024 12:43</span>*/}
              {/*</li>*/}
              {/*<li className="file-for-me-chat">*/}
              {/*  <p className="username-message-chat">*/}
              {/*    Админ или юзер*/}
              {/*  </p>*/}
              {/*  <img src="layout/assets/svg/file_send.svg" alt=""*/}
              {/*       className="file-send-chat-message"/>*/}
              {/*  1 файл pdf*/}
              {/*  <span className="message-date-time">12.02.2024 12:43</span>*/}
              {/*</li>*/}
            </ul>
          </div>
          <div className="block-send-chat">
            {fileSend ? (
              "Отправка файла..."
            ) : (
              <>
                <textarea
                  className="messanger-input"
                  rows={1}
                  placeholder="Введите текст сообщения"
                  value={messageRequest?.text}
                  onChange={e =>
                    setMessageRequest({
                      userId: userId,
                      type: type,
                      instanceId: instanceId,
                      text: e.target.value
                    })
                  }
                  onKeyDown={handleKeyDown}
                  onKeyUp={handleKeyUp}
                  style={{ resize: "none" }}
                />
                <CommonFileInput
                  label={""}
                  placeholder={""}
                  name={""}
                  errorModel={undefined}
                  _callback={f => submitFile(f)}
                  noFieldset={true}
                />
                <button className="send-message-btn" onClick={submit} />
              </>
            )}
          </div>
        </div>
      </section>
    )
  } else {
    return <></>
  }
}
